import request from '@/utils/request'

// 查询订单详情
export function queryStoreOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单商品
export function queryStoreOrderCart(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单地址
export function queryStoreOrderAddress(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单事件
export function queryOrderEvent(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryOrderEvent',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单优惠
export function queryStoreOrderDiscount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderDiscount.queryStoreOrderDiscount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询分账信息
export function listStoreOrderLedgerAcct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderLedgerAcct.listStoreOrderLedgerAcct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单费用
export function queryStoreOrderCartFee(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCartFee',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}